import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface RemoveProductParams {
	productName: string;
}
interface DialogState {
	open: {
		removeProduct: boolean;
		exitQuote: boolean;
		referQuote: boolean;
		bindQuote: boolean;
		confirm: boolean;
		updateQuote: boolean;
	};
	params: {
		removeProduct: any;
		exitQuote: any;
		referQuote: any;
		bindQuote: any;
		confirm: any;
		updateQuote: any;
	};
}

type OpenDialogPayload =
	| keyof DialogState['open']
	| { key: keyof DialogState['open']; params?: any };

const initialState: DialogState = {
	open: {
		removeProduct: false,
		exitQuote: false,
		referQuote: false,
		bindQuote: false,
		confirm: false,
		updateQuote: false,
	},
	params: {
		removeProduct: {
			productName: '',
		},
		exitQuote: {},
		referQuote: {},
		bindQuote: {},
		confirm: {},
		updateQuote: {},
	},
};

export const dialogSlice = createSlice({
	name: 'dialogSlice',
	initialState,
	reducers: {
		// openDialog: (state, action: PayloadAction<keyof DialogState['open']>) => {
		// 	state.open[action.payload] = true;
		// },
        openDialog: (state, action: PayloadAction<OpenDialogPayload>) => {
			if (typeof action.payload === 'string') {
				// If only the key is provided
				state.open[action.payload] = true;
			} else {
				// If key + params are provided
				const { key, params } = action.payload;
				state.open[key] = true;
				if (params) {
					state.params[key] = params;
				}
			}
		},
		closeDialog: (state, action: PayloadAction<keyof DialogState['open']>) => {
			state.open[action.payload] = false;
			state.params[action.payload] = {};
		},
		closeAllDialogs: (state) => {
			state.open = initialState.open;
			state.params = initialState.params;
		},
	},
});

export const { openDialog, closeDialog, closeAllDialogs } = dialogSlice.actions;
export default dialogSlice.reducer;
